<form *ngIf="lugarExpedicionForm" [formGroup]="lugarExpedicionForm" class="row d-flex justify-content-start align-items-center">
    <div class="row">
        <div class="col-sm-6">
            <!-- Razón social -->
            <div class="">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Nombre</mat-label>
                    <input [formControlName]="'nombreLugar'" matInput>
                    <mat-hint>Este nombre puede ser el de tu sucursal o uno que te ayude a identificar fácilmente tu
                        lugar de expedición habitual.</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="col-sm-6">
            <!-- Régimen fiscal -->
            <div class="sm:col-span-4">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Descripción</mat-label>
                    <input [formControlName]="'descripcionLugar'" matInput>
                </mat-form-field>
            </div>
        </div>
    </div>

    <div class="row mt-7">
        <div class="col-sm-6">
            <!-- Folio de inicio -->
            <div class="sm:col-span-2">
                <mat-form-field class="fuse-mat-no-subscript w-full">
                    <mat-label>Código postal</mat-label>
                    <input [formControlName]="'CP'" (blur)="onCPBlur()" maxlength="5" matInput>
                    <mat-error *ngIf="lugarExpedicionForm.controls['CP'].hasError('notFound')">
                        <strong>Código postal no encontrado. Verifica e intenta nuevamente.</strong>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>        

        <div class="col-sm-6">
            <!-- Estado -->
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>Estado: </mat-label>
                <mat-select [panelClass]="isEstadoReadOnly ? 'hidden' : ''"
                    [ngClass]="{'disabledsel': isEstadoReadOnly}" [formControlName]="'estado'"
                    [disabled]="isEstadoReadOnly" placeholder="Seleccione">
                    <mat-option *ngFor="let estado of lstEstado" [value]="estado.id">
                        {{ estado.attributes.nombre }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12 text-right">
            <button mat-button (click)="toggleOpcionales()">
                <mat-icon>{{ opcionales ? 'expand_less' : 'expand_more' }}</mat-icon>
                {{ opcionales ? 'Ocultar datos opcionales' : 'Agregar datos opcionales' }}
            </button>
            <!-- <a href="javascript:void(0);" (click)="abrirFormularioDireccion()">
                Agregar datos opcionales
            </a> -->
        </div>
    </div>

    <div class="row" *ngIf="opcionales">
        <!-- Divider -->
        <div class="my-10 border-t"></div>

        <!-- Calle -->
        <div class="col-sm-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>Calle:</mat-label>
                <input matInput placeholder="Calle" formControlName="calle" maxlength="30"
                    oninput="this.value = this.value.toUpperCase()"
                    onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)
                    || (event.charCode >= 44 && event.charCode <= 46) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))" />
            </mat-form-field>
        </div>

        <!-- No. Exterior -->
        <div class="col-sm-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>No. Exterior:</mat-label>
                <input matInput placeholder="No. Exterior" formControlName="noExterior" />
            </mat-form-field>
        </div>

        <!-- No. Interior -->
        <div class="col-sm-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>No. Interior:</mat-label>
                <input matInput placeholder="No. Interior" formControlName="noInterior" />
            </mat-form-field>
        </div>

        <!-- País -->
        <div class="col-sm-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>País:</mat-label>
                <mat-select [panelClass]="isPaisReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isPaisReadOnly}"
                    name="pais" [disabled]="true" placeholder="Seleccione" formControlName="pais"
                    (selectionChange)="changePais()">
                    <mat-option *ngFor="let pais of lstPais" [value]="pais.id">
                        {{ pais.attributes.nombre }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Municipio -->
        <div class="col-sm-4">
            <mat-form-field class="fuse-mat-no-subscript w-full">
                <mat-label>Municipio: </mat-label>
                <mat-select [panelClass]="isMunicipioReadOnly ? 'hidden' : ''"
                    [ngClass]="{'disabledsel': isMunicipioReadOnly}" name="municipio" placeholder="Seleccione"
                    formControlName="municipio" (selectionChange)="changeMunicipio()">
                    <mat-option *ngFor="let municipio of lstMunicipio" [value]="municipio.id">
                        {{ municipio.attributes.nombre }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Colonia -->
        <div class="col-sm-4">
            <mat-label>Colonia: </mat-label>
            <mat-form-field class="fuse-mat-no-subscript w-full" *ngIf="!isColoniaManual">
                <mat-select name="tipo" placeholder="Seleccione" formControlName="colonia">
                    <mat-option *ngFor="let asentamiento of lstAsentamiento" [value]="asentamiento.id">
                        {{ asentamiento.attributes.nombre }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="lugarExpedicionForm.controls['colonia'].errors?.['required']">
                    <strong>Campo Requerido</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="custom-field" appearance="outline" *ngIf="isColoniaManual">
                <input matInput placeholder="Colonia" formControlName="coloniaManual" minlength="1">
            </mat-form-field>

            <small class="floatRight" *ngIf="isColoniaManual">
                <p class="buttoLikehref" (click)="changeVerManualmente(false);">Ver opciones</p>
            </small>

            <small class="floatRight" *ngIf="!isColoniaManual">
                <p class="buttoLikehref" (click)="changeVerManualmente(true);">Ingresar manualmente</p>
            </small>
        </div>

    </div>

</form>